import { Component, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'ifbp-getting-started',
    templateUrl: './getting-started.component.html',
    styleUrls: ['./getting-started.component.scss'],
    standalone: false
})
export class GettingStartedComponent {
  @Output() navigate = new EventEmitter<string>();

}
